import type { ReactNode } from 'react'

/** A page's title block — the prototype's `.global-settings-header`
 * (subscription-portal.html): a 20px/600 title 2px above a 13px secondary
 * subtitle, 24px above the tabs: the header row's 20px margin plus the
 * block's own 4px, which — as in the prototype — counts in the box the
 * Save/Discard pair (`actions`, the `.pg-act` buttons) is centred on. The
 * buttons sit beside the whole block, so they never make the title row
 * taller than its 30px line and push the subtitle and tabs down. */
export function PageHeader({
  title,
  subtitle,
  actions,
}: Readonly<{ title: ReactNode; subtitle: ReactNode; actions?: ReactNode }>) {
  return (
    <div className="flex items-center justify-between gap-2 mb-5">
      <div className="min-w-0 mb-1">
        <h1 className="text-[20px] font-semibold mb-0.5">{title}</h1>
        <p className="text-[13px] text-[var(--text-secondary)]">{subtitle}</p>
      </div>
      {actions}
    </div>
  )
}
